module.exports = __webpack_public_path__ + "static/media/alertAnnouncement.887fab9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alertAnnouncement.svg
// module id = 437
// module chunks = 0